import React from 'react';
import classNames from 'classnames';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import css from './FormField.css';
import { QuestionMark } from '../../components/widgets';
import sharedCss from './styles.css';

const FormField = ({ title, containerClass, subTitle, tooltip, required, children }) => (
    <div className={classNames(css.container, containerClass)}>
        <div className={css.titleContainer}>
            <span className={css.fieldTitle}>
                {required && <span className={css.required}>*</span>}
                <Translate id={title} />
                {tooltip && <QuestionMark message={tooltip} />}
            </span>
            <span className={sharedCss.subtitle}>
                <Translate id={subTitle} />
            </span>
        </div>
        {children}
    </div>
);

FormField.propTypes = {
    title: PropTypes.string,
    containerClass: PropTypes.string,
    tooltip: PropTypes.string,
    required: PropTypes.bool,
    children: PropTypes.node,
};

export default FormField;
